import React, { Component } from "react";

class Legal extends Component {
  render() {
    return (
      <div className="container presentation">
        <div className="row blockquote text">
              - SE Guido HERRE au capital social de 1000€
        </div>
        <div className="row blockquote text">
            - Immatriculé au Registre du Commerce de Strasbourg sous le numéro TI 450 781 349
        </div>
        <div className="row blockquote text">
            - SIRET 450 781 349 000 11
        </div>
        <div className="row blockquote text">
            - Le siège social est situé au  24, rue du général Leclerc – 67550 VENDENHEIM
        </div>
        <div className="row blockquote text">
            - N° de TVA en application de l’article 286 ter du code général des impôts : FR32450781349
        </div>
      </div>
    );
  }
}

export default Legal;
